import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { styled, theme } from "@theme/stitches.config"

export const StyledPrimitiveRadioGroup = styled(RadioGroupPrimitive.Root, {
    marginTop: 20
})
export const StyledRadio = styled(RadioGroupPrimitive.Item, {
    backgroundColor: "white",
    width: 25,
    height: 25,
    padding: 0,
    marginRight: 10,
    marginBottom: 10,
    borderRadius: "100%",
    "&:focus": {
        boxShadow: `0 0 0 2px ${theme.colors.N100}`
    }
})

export const StyledIndicator = styled(RadioGroupPrimitive.Indicator, {
    display: "flex",
    placeItems: "center",
    position: "relative",
    "&::after": {
        content: "''",
        display: "block",
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        width: 11,
        height: 11,
        minWidth: 11,
        minHeight: 11,
        borderRadius: "50%",
        backgroundColor: theme.colors.N900
    }
})

export const RadioWrapper = styled("div", {
    display: "flex"
})

export const StyledLabel = styled("div", {
    color: "white",
    marginBottom: 8
})
